import { Box } from "@mui/material";

export default function FormRow({ children, noWhap, sx, ...props }) {
    return (
        <Box sx={{ display: "flex", flexBasis: "100%", flexWrap: noWhap ? 'none' : "wrap", gap: 2, ...sx }} {...props}>
            {children}
        </Box>
    );
}
